import React from 'react';
import { ProfileIdentitySearch } from 'features/profiles/ProfileIdentitySearch';
import { talosBadgesLogoURL } from 'config/constants';
import '../gallery/BadgeGalleryView.css';
import './ExploreProfilesView.css';

interface ExploreProfilesViewProps {
  currentProfileId: string | null;
  onSelectProfile: (profileId: string) => void;
  onClearProfile?: () => void;
}

export const ExploreProfilesView: React.FC<ExploreProfilesViewProps> = ({
  currentProfileId,
  onSelectProfile,
  onClearProfile,
}) => (
  <div className="explore-page gallery-page">
    <header className="gallery-header">
      <ProfileIdentitySearch
        selectedProfileId={currentProfileId}
        onSelectProfile={onSelectProfile}
        onClear={onClearProfile}
        avatarSrc={talosBadgesLogoURL}
        defaultMenuOpen
        autoFocus
      >
        <h1 className="gallery-title">Find Profile</h1>
        <p className="gallery-subtitle">Search anyone&apos;s profile — jump by name or email.</p>
      </ProfileIdentitySearch>
    </header>
  </div>
);
